import Modal from 'src/components/Modal'
import * as S from './ConfirmOrRejectModal.styles'

interface ConfirmOrRejectModalProps {
  show: boolean
  title: string
  headerBackgroundColor?: string
  description?: string
  customizableDescription?: JSX.Element
  dataTestId?: string
  size?: 'sm' | 'lg' | 'xl'
  onConfirm: () => any
  onReject: () => any
  onClose: () => any
  confirmButtonText?: string
  rejectButtonText?: string
  zIndex?: number
}

export default ({
  show,
  title,
  headerBackgroundColor,
  description,
  customizableDescription,
  dataTestId,
  size,
  onConfirm,
  onReject,
  onClose,
  confirmButtonText,
  rejectButtonText,
  zIndex = 1040,
}: ConfirmOrRejectModalProps) => (
  <Modal
    show={show}
    testId={dataTestId}
    centered
    title={title}
    headerBackgroundColor={headerBackgroundColor}
    closeButtonAction={onClose}
    body={(
      <S.ModalBody>
        <S.ModalText>
          {description || customizableDescription}
        </S.ModalText>
        <S.ModalFooter>
          <S.ConfirmButton onClick={onConfirm} data-testid='confirm-button-test'>
            {confirmButtonText || 'Sim'}
          </S.ConfirmButton>
          <S.CancelButton onClick={onReject} data-testid='cancel-button-test'>
            {rejectButtonText || 'Não'}
          </S.CancelButton>
        </S.ModalFooter>
      </S.ModalBody>
      )}
    closedButton
    size={size}
    zIndex={zIndex}
  />
)
